import * as tslib_1 from "tslib";
import { jsonMember, jsonObject } from "typedjson";
import { DxBaseControlOptions } from "./dx-base-control-options";
let DxInputControlOptions = class DxInputControlOptions extends DxBaseControlOptions {
    get placeholder() {
        return this._placeholder;
    }
    set placeholder(value) {
        this._placeholder = value;
    }
    get isFocused() {
        return this._isFocused;
    }
    set isFocused(value) {
        this._isFocused = value;
    }
};
tslib_1.__decorate([
    jsonMember({ name: "placeholder", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], DxInputControlOptions.prototype, "_placeholder", void 0);
tslib_1.__decorate([
    jsonMember({ name: "isFocused", constructor: Boolean, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Boolean)
], DxInputControlOptions.prototype, "_isFocused", void 0);
DxInputControlOptions = tslib_1.__decorate([
    jsonObject
], DxInputControlOptions);
export { DxInputControlOptions };
